<template>
  <div class="drugintro-box">
    <div class="header-img">
      <img src="../../assets/images/drugIntro/0331/banner.png" alt="" width="100%"/>
    </div>
    <div class="rule-box">
      <img src="../../assets/images/drugIntro/0331/des01.png" alt="" width="100%"/>
      <img src="../../assets/images/drugIntro/0331/des02.png" alt="" width="100%"/>
      <img src="../../assets/images/drugIntro/0331/des03.png" alt="" width="100%"/>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goDrug () {
      /* eslint-disable */
      dsBridge.call('callNativeView', {
        androidGoPage: '/drug/DrugHomeActivity',
        iosGoPage: 'GXGYHomeViewController'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.drugintro-box {
  min-height: 100vh;
  img {
    display: block;
  }
}
.btn-box {
  width: 90%;
  position: absolute;
  top: 0;
  left: 5%;
}
.rule-box {
  position: relative;
}
</style>
